var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOutlineShare24Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 31,
    viewBox: "0 0 28 31",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "premiumIcon",
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M23.29 21.776c-1.18 0-2.236.464-3.044 1.191l-11.07-6.418c.078-.356.14-.712.14-1.083s-.062-.727-.14-1.083l10.946-6.356a4.647 4.647 0 0 0 3.167 1.253 4.643 4.643 0 0 0 4.658-4.64c0-2.568-2.08-4.64-4.658-4.64a4.643 4.643 0 0 0-4.657 4.64c0 .371.062.727.14 1.082L7.824 12.08a4.647 4.647 0 0 0-3.167-1.253A4.643 4.643 0 0 0 0 15.466c0 2.567 2.08 4.64 4.658 4.64 1.226 0 2.329-.48 3.167-1.253l11.055 6.434a4.347 4.347 0 0 0-.124 1.005c0 2.49 2.034 4.516 4.533 4.516 2.5 0 4.534-2.026 4.534-4.516s-2.034-4.516-4.534-4.516zm0-18.683c.853 0 1.552.696 1.552 1.547 0 .85-.699 1.546-1.553 1.546a1.554 1.554 0 0 1-1.552-1.546c0-.85.698-1.547 1.552-1.547zM4.657 17.013a1.554 1.554 0 0 1-1.553-1.547c0-.85.699-1.547 1.553-1.547s1.553.696 1.553 1.547c0 .85-.7 1.547-1.553 1.547zM23.289 27.87a1.554 1.554 0 0 1-1.552-1.547c0-.85.698-1.546 1.552-1.546.854 0 1.553.696 1.553 1.546 0 .85-.699 1.547-1.553 1.547z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOutlineShare24Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/outline-share-24-px.11f1881439a3fc8ee235a4576bd104bd.svg";